import moment from 'moment';

const shouldUpdateOrgs = orgs => {
    return orgs._lastRetrieved && moment().diff(moment.unix(orgs._lastRetrieved), 'minutes') > 30;
};

export default {
    shouldUpdateOrgs
};
